import Box from '@mui/material/Box'
import FormHelperText from '@mui/material/FormHelperText'
import FormInputBase from './FormInputBase'

const FormControlList = ({ formProps, inputConfig, itemProps }) => {
  const { onSubmit, inputProps, component } = inputConfig
  const { disabled } = itemProps
  const { field: { value = [], name, onChange } = {}, fieldState: { error } = {} } = formProps

  return (
    <FormInputBase
      error={error}
      onSubmit={
        onSubmit
          ? () => {
              onSubmit(value)
            }
          : null
      }
      inputProps={inputProps}
    >
      <Box>
        {value.map((val, index) => (
          <Box key={`ctrlListItem_${name}_${index * 2}}`} padding={1}>
            {component({ value: val, index, onChange, disabled })}
          </Box>
        ))}
        {error && error.message && <FormHelperText error>{error.message}</FormHelperText>}
      </Box>
    </FormInputBase>
  )
}

export default FormControlList
